module.exports = __webpack_public_path__ + "media/images/pages/i-belong/text_icon-67de984dcfbbb52c2d32b7dcf74776c9.svg";